import { styled } from 'styled-components';
import { Flex } from 'antd';

// The ui-kit caps the inline edit form at 190px when fitContent is on, and
// turning fitContent off would also stretch the view text's hover highlight
// to the full container. Keep fitContent on (hover hugs the text) and widen
// only the edit form to this 500px container, matching the Type dropdown's
// selectWidth below.
export const STitleInputWrapper = styled(Flex)`
  width: 500px;
  max-width: 100%;

  /* &&& outranks the ui-kit's doubled-class 190px cap on .editable-form */
  &&& .editable-form {
    max-width: 100%;
    width: 100%;
  }
`;
